var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBscChain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.64729 0L2.96693 2.75952L4.68938 3.77856L7.64729 2.02906L10.6142 3.77856L12.3367 2.75952L7.64729 0ZM1.72244 7.5481V5.51904L3.45391 4.5L1.72244 3.48096L0 4.5V6.52906L1.72244 7.5481ZM1.73146 12.481L1.72244 9L0 7.98096V13.509L4.68938 16.2595V14.2214L1.73146 12.481ZM5.92485 4.5L7.64729 3.48096L9.37876 4.5L7.64729 5.51904L5.92485 4.5ZM4.68938 10.7405L2.96693 9.72144V11.7595L4.68938 12.7695V10.7405ZM5.92485 14.9519L7.64729 15.9709L9.37876 14.9519V16.981L7.64729 18L5.92485 16.981V14.9519ZM13.5721 3.48096L11.8497 4.5L13.5721 5.51904V7.5481L15.3036 6.52906V4.5L13.5721 3.48096ZM13.5721 12.481L13.5812 9L15.3036 7.98096V13.509L10.6142 16.2595V14.2214L13.5721 12.481ZM10.6142 12.7695L12.3367 11.7595V9.72144L10.6142 10.7405V12.7695ZM12.3367 6.24048L12.3457 8.27856L9.37876 10.019V13.509L7.65631 14.519L5.93387 13.509V10.019L2.96693 8.27856V6.24048L4.6984 5.22144L7.64729 6.97094L10.6142 5.22144L12.3457 6.24048H12.3367Z",
    fill: "#F9B72D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBscChain);
export default __webpack_public_path__ + "static/media/bsc-chain.ed29fe4e.svg";
export { ForwardRef as ReactComponent };